export default __webpack_public_path__ + "static/media/email-campaign-rafiki.060ec598.svg";